module.exports = __webpack_public_path__ + "img/work5-1.5d40dfed.png";